import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { models, IEmbedConfiguration, service } from 'powerbi-client';
import 'powerbi-report-authoring';

import api from '../../services/api';

import * as S from './styles';
import './style.css';

interface RouterParams {
  company?: string | undefined;
  report?: string | undefined;
}

const Embedded: React.FC = () => {
  const { company, report } = useParams<RouterParams>();
  const [loading, setLoading] = useState(false);

  const [reportConfig, setReportConfig] = useState<IEmbedConfiguration>({
    type: 'report',
    id: report,
    embedUrl: undefined,
    tokenType: models.TokenType.Embed,
    accessToken: '',
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
    },
  });

  const embeddedToken = useCallback(async () => {
    setLoading(true);

    try {
      const response = await api.get(
        `/integration/embedded/${company}/${report}`,
      );

      setReportConfig({
        ...reportConfig,
        id: response.data.reportId,
        accessToken: response.data.token,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, report]);

  useEffect(() => {
    embeddedToken();
  }, [embeddedToken]);

  // Map of event handlers to be applied to the embedding report
  const eventHandlersMap = new Map([
    [
      'loaded',
      () => {
        // Quando relatorio esta carregando
        //  console.log('Report has loaded');
      },
    ],
    [
      'rendered',
      () => {
        // Quando o relatorio finaliza
        // console.log('The report is rendered');
      },
    ],
    [
      'error',
      (event?: service.ICustomEvent<any>) => {
        if (event) {
          console.error(event.detail);
        }
      },
    ],
  ]);

  return (
    <S.Container>
      {!loading && (
        <S.Embedded
          embedConfig={reportConfig}
          eventHandlers={eventHandlersMap}
          cssClassName="report-class-full"
          // getEmbeddedComponent={(embedObject: Embed) => {
          //   console.log(
          //     `Embedded object of type "${embedObject.embedtype}" received`,
          //   );
          // }}
        />
      )}
    </S.Container>
  );
};

export default Embedded;
